module.exports = __webpack_public_path__ + "static/media/Save.22dfe7e7.svg";